import { actions } from '../actions';
import { JOB_NAMES } from 'common/services/jobs-suites.service';

const initialState = Object.values(JOB_NAMES).reduce((acc, val) => {
  acc[val] = null;
  return acc;
}, {});

export const jobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_JOB_SUCCEED:
      const { jobName, jobDetails } = action.payload;
      return {
        ...state,
        [jobName]: jobDetails
      };
    default:
      return state;
  }
};
